export const COMPONENT_MAPPER = {
  select: 'SelectInput',
};

export const INPUT_TYPE_MAPPER = {
  string: 'text',
};

export const DEFAULT_COMPONENT = 'TextInput';
